<template>
	<div>
		<!-- <h3 class="ch-block-title text-left text-uppercase mb-0">
			Video Preview
		</h3> -->
		<div class="d-flex flex-column flex-wrap">
			<iframe
				width="560"
				height="315"
				style="width: 100%; height: 250px"
				:src="videoUrl"
				frameborder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowfullscreen
			></iframe>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		video: {
			type: Object,
			default: () => {},
		},
	},
	computed: {
		videoUrl() {
			return this.video.url + "?showinfo=0&controls=0"
		},
	},
}
</script>

<style lang="scss" scoped>
</style>